import { render, staticRenderFns } from "./SkinCard.vue?vue&type=template&id=e6f82d8c&scoped=true&"
import script from "./SkinCard.vue?vue&type=script&lang=js&"
export * from "./SkinCard.vue?vue&type=script&lang=js&"
import style0 from "./SkinCard.vue?vue&type=style&index=0&id=e6f82d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f82d8c",
  null
  
)

export default component.exports